import * as React from "react";
const SvgFiRrCallOutgoing = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-call-outgoing_svg__a)">
      <path
        fill="#062147"
        d="M23.98 2.023v4a1 1 0 1 1-2 0V3.46l-5.3 5.272a1 1 0 0 1-1.41-1.418l5.32-5.291h-2.61a1 1 0 0 1 0-2h4a2 2 0 0 1 2 2m-.905 14.739a3.1 3.1 0 0 1 0 4.378l-.912 1.05c-8.191 7.838-28.12-12.085-20.4-20.3l1.149-1A3.085 3.085 0 0 1 7.24.928c.03.03 1.883 2.439 1.883 2.439a3.1 3.1 0 0 1-.006 4.28l-1.16 1.458a12.78 12.78 0 0 0 6.932 6.945l1.465-1.165a3.1 3.1 0 0 1 4.28-.006s2.409 1.853 2.44 1.883M21.7 18.216s-2.393-1.842-2.424-1.872a1.1 1.1 0 0 0-1.55 0c-.026.026-2.043 1.634-2.043 1.634a1 1 0 0 1-.98.152A15 15 0 0 1 5.88 9.318a1 1 0 0 1 .145-.995s1.607-2.017 1.634-2.044a1.1 1.1 0 0 0 0-1.55c-.03-.03-1.872-2.423-1.872-2.423a1.1 1.1 0 0 0-1.51.038l-1.15 1c-5.643 6.782 11.63 23.098 17.573 17.482l.912-1.05a1.12 1.12 0 0 0 .088-1.56"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-call-outgoing_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCallOutgoing;
